var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-avatar"},[_c('div',{staticClass:"avatar"},[_c('el-avatar',{attrs:{"shape":"square","size":150,"src":_vm.computedAvatar,"fit":'cover'}})],1),_c('div',{staticClass:"code"},[_vm._v("Mã: "+_vm._s(_vm.code))])])
}
var staticRenderFns = []

export { render, staticRenderFns }